export const actionTypes = {
    SET_PRODUCTS: "SET_PRODUCTS",
    SELECTED_PRODUCT: "SELECTED_PRODUCT",
    ADD_TO_CART: "ADD_TO_CART",
    REMOVE_CART: "REMOVE_CART",
    RMV_ONE:"RMV_ONE"
};